<template>
    <tab-layout>
        <!-- TAB TITLE -->
        <template #title>
            {{ $l10n.__('Informations Générales') }}
        </template>

        <!-- TAB CONTENT -->
        <template #content>
            <div :class="mainClasses">
                <!-- PERSONAL -->
                <section class="flex">
                    <h3 class="m-3 flex-row baseline">{{ $l10n.__('Le contact') }}</h3>

                    <div class="px-3 br-1">
                        <div>
                            <h4 class="m-0">{{ $l10n.__('Personnelle') }}</h4>
                            <ul>
                                <li
                                    v-for="(item, indexItem) in removeEmptyValue(general)"
                                    :key="indexItem"
                                    class="data-block data-block-hover"
                                >
                                    <!-- Dynamic load data component -->
                                    <component
                                        :is="item.format + '-data'"
                                        v-bind="item"
                                        :useFavorite="!!item.favoriteName"
                                        :list="favorites"
                                        @toggleFavorite="updateFavorites(item)"
                                    >
                                    </component>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>

                <!-- COMPANY -->
                <section class="flex">
                    <h3 class="m-3 flex-row baseline">
                        <span class="flex-right">
                            <link-button
                                :permissions="$store.getters.permissions"
                                permToCheck="can_edit"
                                :data-bot="databot['generalinfoedit1']"
                                @clicked="edit"
                            >
                                {{ $l10n.__('Editer') }}
                            </link-button>
                        </span>
                    </h3>

                    <div class="px-3">
                        <div v-for="(third, thirdIndex) in linkedThirds" :key="thirdIndex">
                            <h4 class="m-0">{{ third.name }}</h4>
                            <ul>
                                <li
                                    v-for="(item, indexItem) in removeEmptyValue(third.data)"
                                    :key="indexItem"
                                    class="data-block data-block-hover"
                                >
                                    <!-- Dynamic load data component -->
                                    <component
                                        :is="item.format + '-data'"
                                        v-bind="item"
                                        :useFavorite="!!item.favoriteName && thirdIndex === 0"
                                        :list="favorites"
                                        :index="thirdIndex"
                                        @toggleFavorite="updateFavorites(item)"
                                    >
                                    </component>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>

                <!-- SELLSY -->
                <sellsy-informations-section
                    :linkedid="$store.getters.linkedid"
                    :linkedtype="$store.getters.linkedtype"
                    :enableTags="true"
                    :data="$store.getters.sellsyInformations"
                    :canDisplayMassMailingConsent="canDisplayMassMailingConsent"
                />
            </div>

            <MarketingConsentOverview v-if="canDisplayMarketingConsent" />
        </template>
    </tab-layout>
</template>

<script>
import LinkButton from 'vcomponents/utilities/LinkButton.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import MarketingConsentOverview from 'vcomponents/marketing/consent/MarketingConsentOverview.vue';
import SellsyInformationsSection from './SellsyInformationsSection.vue';
import Text from './data/Text.vue';
import Textarea from './data/Textarea.vue';
import Link from './data/Link.vue';
import ExternalLink from './data/ExternalLink.vue';
import Phone from './data/Phone.vue';
import Email from './data/Email.vue';

export default {
    components: {
        'sellsy-informations-section': SellsyInformationsSection,
        'text-data': Text,
        'textarea-data': Textarea,
        'link-data': Link,
        'external_url-data': ExternalLink,
        'phone-data': Phone,
        'email-data': Email,
        'link-button': LinkButton,
        TabLayout,
        MarketingConsentOverview,
    },
    data() {
        return {
            mapping: this.$store.getters.dataMap,
        };
    },
    computed: {
        linkedThirds() {
            return this.$store.getters.third;
        },
        general() {
            return this.$store.getters.informations;
        },
        favorites() {
            return this.$store.getters.favorites;
        },
        routes() {
            return this.$store.getters.routes;
        },
        databot() {
            return this.$store.getters.databots;
        },
        permissions() {
            return this.$store.getters.permissions;
        },
        mainClasses() {
            return ['well p-0 pb-3 flex-level flex-top ovx-auto overview__general-info'];
        },
        canDisplayMarketingConsent() {
            return this.permissions.can_show_rgpd_consents;
        },
        canDisplayMassMailingConsent() {
            return this.permissions.can_show_campaign_subscription;
        },
    },
    methods: {
        removeEmptyValue(list) {
            return list.filter((item) => item.value && item.value !== '');
        },
        edit() {
            window.People.edit('peopleOverview', this.$store.getters.linkedid);
        },
        updateFavorites(item) {
            const peopleRoute = this.routes.find((route) => route.id === 'favorite');
            if (peopleRoute) {
                this.$store.dispatch('updateFavorites', { item: item, route: peopleRoute.value });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.overview__general-info {
    flex: 1 0 auto;
}
</style>
